<template>
  <v-dialog v-model="show" max-width="1200" persistent v-if="show">
    <v-card>
      <v-card-title>Cliente:{{nombreDeCliente}} - Abono múltiple   </v-card-title>
      <v-container>
        <v-row>
          <v-col cols="12" xl="12">
            <v-text-field
              v-model="cantidadAbonar"
              autofocus
              @focus="$event.target.select()"
              outlined
              dense
              label="Cantidad a abonar"
            ></v-text-field>

            <v-select
            dense
              v-model="metodoPago"
              item-text="texto"
              item-value="valor"
              :items="['Efectivo', 'Transferencia', 'Deposito']"
              label="Método de pago"
              outlined
            ></v-select>
            Adeudo actual de este cliente: <span style="font-weight:bold;"> {{ formateaMoneda(deudaUnSoloCliente) }}</span><br>
            Nombre del cliente:<span style="font-weight:bold;"> {{nombreDeCliente}}</span><br>
            Teléfono del cliente:<span style="font-weight:bold;"> {{telefonoDeCliente}}</span>
          </v-col>
        </v-row>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="$emit('cerrar-modal-abono-multiple')" color="blue darken-1" text
            >Cancelar</v-btn
          >
          <v-btn color="blue darken-1" @click="ejecutarAbonoMultiple()" text>Aceptar</v-btn>
        </v-card-actions>
      </v-container>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapActions, mapState } from "vuex";
import { FormatoMoneda, FormatoGuia } from "@/Utils/Utils";
export default {
  async mounted() {
    await this.getDeudaUnRemitente(this.idClientePasado);
  },
  data: () => ({
    cantidadAbonar: 0,
    metodoPago: "Efectivo"
  }),
  props: { show: Boolean, idClientePasado: Number, nombreDeCliente: String,telefonoDeCliente:String },
  computed: {
    ...mapState("abonosEnvios", {
      deudaUnSoloCliente: state => state.deudaUnSoloCliente
    }),
    ...mapState({
      logedInUserInfo: state => state.sesion.logedInUserInfo,
      sucursalInfo: state => state.sesion.sucursalData,
    })
  },
  methods: {
    ...mapActions("abonosEnvios", ["insertAbonoMultiple", "getDeudaUnRemitente","registraNombreAbonante"]),
    async ejecutarAbonoMultiple() {
      await this.registraNombreAbonante(this.nombreDeCliente);
      const res = await this.insertAbonoMultiple({
        Remitente: this.idClientePasado,
        idSucursal: this.sucursalInfo.ID,
        Abono: this.cantidadAbonar,
        tipo_pago: this.metodoPago
      });

      if (res[0]) {
        this.$emit("cerrar-modal-abono-multiple");
        this.$emit("actualizarAbonosMultiples");
      }
    },
    formateaMoneda(moneda) {
      return FormatoMoneda.format(moneda);
    },
  }
};
</script>
